import { maskBr } from "js-brasil";
export function formatCpfCnpj(cpfCnpj) {
  const formatedCpfCnpj =
    cpfCnpj.length > 11 ? maskBr.cnpj(cpfCnpj) : maskBr.cpf(cpfCnpj);

  return formatedCpfCnpj;
}
